export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/watermark.bb1461d6.svg","height":33,"width":29,"blurWidth":0,"blurHeight":0};